export default "__VITE_ASSET__8173acf5__"